module.exports = __webpack_public_path__ + "img/China-TaiBao.5f2059c5.png";